import { Box } from '@mui/material'
import CustomText from 'components/common/CustomText/CustomText'
import { colors } from 'styles/colors'
import useGlobalStyles from 'styles/globalStyles'
import EducationOptions from './EducationOptions'

interface Props {
  item: any;
}

export default function EducationItem({ item }: Props) {
  const globalStyles = useGlobalStyles();

  return (
    <Box
      className={globalStyles.positionItemContainer}
      display="flex"
      height="100%"
      justifyContent={'space-between'}
      alignItems={'flex-start'}
    >
      <Box
        height="100%"
        display="flex"
        flexDirection="column"
      >

        {/* Speciality */}
        <CustomText
          text={item.speciality.name}
          fontSize={16}
          color={colors.primary}
          fontWeight={600}
        />

        {/* Hospital */}
        <CustomText
          text={item.institution_name}
          fontSize={10}
          color={colors.secondary}
          fontWeight={500}
        />

        {/* Dates */}
        <Box mt='auto'>
          <CustomText
            text={`${item.start_date} ${item?.end_date ? ('- ' + item.end_date) : '- Currently'}`}
            fontSize={12}
            color={colors.secondary}
            fontWeight={500}
          />
        </Box>
      </Box>

      <EducationOptions educationId={item.id} />
    </Box>
  )
}
